import { Badge } from "@/components/ui/badge";
import { TInterviewStatus } from "@/actions/types";

export const allScheduleStatusType = [
  "Pending",
  "Upcoming",
  "Cancelled",
  "Rejected",
  "Completed",
] as TInterviewStatus[];

type BadgeScheduleStatusProps = {
  tab: TInterviewStatus;
  status: TInterviewStatus;
};

export function BadgeScheduleStatus({ tab, status }: BadgeScheduleStatusProps) {
  const variants: Record<
    TInterviewStatus,
    | "warning"
    | "outline"
    | "destructive"
    | "default"
    | "secondary"
    | "info"
    | "success"
  > = {
    Pending: "warning",
    Upcoming: "info",
    Cancelled: "secondary",
    Rejected: "destructive",
    Completed: "success",
  };
  return (
    <Badge key={status} variant={variants[status]}>
      {tab.charAt(0).toUpperCase() + tab.slice(1)}
    </Badge>
  );
}
